import { GridContainer } from 'libs/ui';
import { Booking } from 'grids/booking/booking';

export const BookingWrapper = (props) => {
  return (
    <GridContainer>
      <Booking {...props} />
    </GridContainer>
  );
};
